<template>
  <div class="heading-elements">
    <ul class="list-inline mb-0">
      <li v-if="availableActions.includes('collapse')">
        <a
          data-action="collapse"
          :class="{ rotate: isCollapsed }"
          @click="$emit('collapse')"
        >
        <slot name="collapse-icon">

          <feather-icon
            icon="ChevronDownIcon"
            size="16"
          />
        </slot>

        </a>
      </li>
      <li v-if="availableActions.includes('refresh')">
        <a
          data-action="reload"
          @click="$emit('refresh')"
        >
        <slot name="refresh-icon">
          <feather-icon
            icon="RotateCwIcon"
            size="14"
          />
        </slot>
        </a>
      </li>
      <li v-if="availableActions.includes('close')">
        <a
          data-action="close"
          @click="$emit('close')"
        >
        <slot name="close-icon">
          <feather-icon
            icon="XIcon"
            size="14"
          />
        </slot>
        </a>
      </li>
      <!-- New Action -->
      <li v-if="availableActions.includes('new-action')">
        <a
          data-action="new"
          @click="$emit('new-action')"
        >
          <slot name="new-icon">
            <feather-icon icon="PlusIcon" size="16" />
          </slot>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    isCollapsed: {
      type: Boolean,
      requried: true,
    },
    availableActions: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
